module.exports = __webpack_public_path__ + "static/thaw-about-bg-f87b9c14a9c69329eb170d649422466e.png";